module.exports = __webpack_public_path__ + "img/xaas-youtube.3ca6fa6.png";